module.exports = __webpack_public_path__ + "img/ywjz1.c39069fb.png";